export const getLinkRoute = (route: string, params: Record<string, string>) => {
  const re = new RegExp(
    Object.keys(params)
      .map((key) => `:${key}\\b\\??`)
      .join('|'),
    'gm'
  );

  return route.replace(re, (matched) => {
    /** remove ':' and '?' chars from a path, to take only param name.
     *  Example path with optional param: /<routeName>/:permanentUrl?
     * */
    const matchedString = matched[matched.length - 1] === '?' ? matched.slice(1, -1) : matched.slice(1);

    return params[matchedString];
  });
};
